import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React, {useState, useEffect} from 'react';
import {useCookies} from 'react-cookie';
import {Button, Card, Row, Tabs, Tab} from "react-bootstrap";
import EtcDataGrid from "../ui/grid/EtcDataGrid";
import {toast} from "react-toastify";
import {
    connectionErrorMessage,
    errorMessage,
    saveDiscountCouponUrl,
    generateDiscountCouponCodeUrl,
    updateStatusDiscountCouponDtoUrl,
    getDiscountCouponCodeListUrl,
    getDiscountCouponDtoByIdUrl,
    getDiscountCouponListUrl,
    getSelectedTenantListUrl
} from "../data";
import DiscountCouponInputForm from "./DiscountCouponInputForm";
import moment from "moment";
import DiscountCodeInputFormDialog from "./DiscountCodeInputFormDialog";
import {GridRenderCellParams} from "@mui/x-data-grid";
import EtcMultiSelectDataGrid from "../ui/grid/EtcMultiSelectDataGrid";
import {debugLog} from "../debug";


function DiscountManagerPanel({setCookie, removeCookie, adminManagement},props) {
    const [cookies] = useCookies(['subscriptionToken']);
    const [openDiscountCouponInputForm, setDiscountCouponInputForm] = React.useState(false);
    const [openDiscountCodeInputFormDialog, setOpenDiscountCodeInputFormDialog] = React.useState(false);
    const [discountCouponList, setDiscountCouponList] = React.useState([]);
    const [discountCouponCodeList, setDiscountCouponCodeList] = React.useState([]);
    const [selectedTenantList, setSelectedTenantList] = React.useState([]);
    const [selectionModel, setSelectionModel] = useState([]);
    const [updateSelectionDiscountCoupon, setUpdateSelectionDiscountCoupon] = useState({});
    const [openDiscountCouponInputFormType, setOpenDiscountCouponInputFormType] = useState("add");
    const [tabKey, setTabKey] = useState('coupon');

    const handleSaveDiscountCouponInputForm = (discountCouponDto) => {
        fetch(saveDiscountCouponUrl, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(discountCouponDto)
        })
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(errorMessage);
                }
            })
            .then((data) => {
                if (!data) {
                    return;
                }
                getDiscountCouponList();
                handleCloseDiscountCouponInputForm();
            }, (error) => {
                debugLog(error);
                if (error) {
                    toast.error(error.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            });
    };

    const handleCloseDiscountCouponInputForm = () => {
        setDiscountCouponInputForm(false);
    };

    const handleAcceptDiscountCodeInputFormDialog = (codeCount,startPrefixCode) => {
        let discountCouponDto = {};
        discountCouponDto.id = selectionModel[0];
        discountCouponDto.useCouponCodeCount = codeCount;
        discountCouponDto.useCouponCodePrefix = startPrefixCode;
        fetch(generateDiscountCouponCodeUrl, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(discountCouponDto)
        })
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(errorMessage);
                }
            })
            .then((data) => {
                if (!data) {
                    return;
                }
                getDiscountCouponCodeList(selectionModel[0]);
            }, (error) => {
                debugLog(error);
                if (error) {
                    toast.error(error.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            });
        setOpenDiscountCodeInputFormDialog(false);
    };

    const handleCloseDiscountCodeInputFormDialog = () => {
        setOpenDiscountCodeInputFormDialog(false);
    };


    const generateDiscountCouponCode = () => {
        setOpenDiscountCodeInputFormDialog(true);
    };

    const updateSelectionDiscountCouponDto = () => {
        setOpenDiscountCouponInputFormType("edit")
        fetch(getDiscountCouponDtoByIdUrl, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({id:selectionModel[0]})
        })
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(errorMessage);
                }
            })
            .then((data) => {
                if (!data) {
                    return;
                }
                setUpdateSelectionDiscountCoupon(data);
                setDiscountCouponInputForm(true);

            }, (error) => {
                debugLog(error);
                if (error) {
                    toast.error(error.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            });

    };

    const getSelectedTenantList = (selectedId) => {
        fetch(getSelectedTenantListUrl, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({id:selectedId})
        })
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(errorMessage);
                }
            })
            .then((data) => {
                if (!data) {
                    return;
                }
                setSelectedTenantList(data);
            }, (error) => {
                debugLog(error);
                if (error) {
                    toast.error(error.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            });

    };

    const getDiscountCouponCodeList = (discountCouponId) => {
        let discountCouponDto = {};
        discountCouponDto.id = discountCouponId;
        fetch(getDiscountCouponCodeListUrl, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(discountCouponDto)
        })
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(errorMessage);
                }
            })
            .then((data) => {
                if (!data) {
                    return;
                }
                for (let i = 0; i < data.length; i++) {
                    data[i].creationDateTime = moment(data[i].creationDateTime).format("LLL");
                    if(data[i].couponUsageDate){
                        data[i].couponUsageDate = moment(data[i].couponUsageDate).format("LLL");
                    }
                }
                setDiscountCouponCodeList(data);
            }, (error) => {
                debugLog(error);
                if (error) {
                    toast.error(error.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            });
    }

    const onSelectionModelChange = (selection) => {
        const newSelectionModel = selection;

        if (newSelectionModel.length > 1) {
            const selectionSet = new Set(selectionModel);
            const result = newSelectionModel.filter(
                (s) => !selectionSet.has(s)
            );
            setSelectionModel(result);
            getDiscountCouponCodeList(result[0])
            getSelectedTenantList(result[0])
        } else {
            setSelectionModel(newSelectionModel);
            getDiscountCouponCodeList(newSelectionModel[0])
            getSelectedTenantList(newSelectionModel[0])
        }

        if(newSelectionModel && !newSelectionModel.length > 0){
            setDiscountCouponCodeList([]);
            setSelectedTenantList([]);
        }
    }

    useEffect(() => {
        if (!cookies.subscriptionToken) {
            toast.error(connectionErrorMessage, {
                position: toast.POSITION.TOP_CENTER
            });
            return;
        }

        fetch(getDiscountCouponListUrl,
            {
                headers: new Headers({'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken)})
            })
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(errorMessage);
                }
            })
            .then((data) => {
                if (!data) {
                    return;
                }
                moment.locale('tr')
                for (let i = 0; i < data.length; i++) {

                    data[i].validIntervalEndDateTime = moment(data[i].validIntervalEndDateTime).format("LLL");
                    data[i].validIntervalBeginDateTime = moment(data[i].validIntervalBeginDateTime).format("LLL");
                }
                setDiscountCouponList(data);
            }, (error) => {
                debugLog(error);
                if (error) {
                    toast.error(error.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            });

    }, [cookies.subscriptionToken]);

    const getDiscountCouponList = () => {
        fetch(getDiscountCouponListUrl,
            {
                headers: new Headers({'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken)})
            })
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(errorMessage);
                }
            })
            .then((data) => {
                if (!data) {
                    return;
                }
                moment.locale('tr')
                for (let i = 0; i < data.length; i++) {

                    data[i].validIntervalEndDateTime = moment(data[i].validIntervalEndDateTime).format("LLL");
                    data[i].validIntervalBeginDateTime = moment(data[i].validIntervalBeginDateTime).format("LLL");
                }
                setDiscountCouponList(data);
            }, (error) => {
                debugLog(error);
                if (error) {
                    toast.error(error.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            });
    }

    const insertDiscountCouponDto = () => {
        setOpenDiscountCouponInputFormType("add")
        setUpdateSelectionDiscountCoupon(null);
        setDiscountCouponInputForm(true);
    }

    const updateStatusDiscountCouponDto = (status) => {
        fetch(updateStatusDiscountCouponDtoUrl, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({id:selectionModel[0],validityStatusEnumValue:status})
        })
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(errorMessage);
                }
            })
            .then((data) => {
                if (!data) {
                    return;
                }
                getDiscountCouponList();
                getDiscountCouponCodeList(selectionModel[0]);
            }, (error) => {
                debugLog(error);
                if (error) {
                    toast.error(error.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            });
    }

    return (<div style={{paddingLeft:20,paddingRight:20}}>
        <Row>
            <Card style={{width: "100%"}}>
                <Card.Body className="align-items-center align-middle font-weight-bold p-1"
                           style={{
                               width: "100%",
                               height: "35vh",
                               padding: '0 !important'
                           }}>
                    <EtcDataGrid
                        onSelectionModelChange={onSelectionModelChange}
                        selectionModel={selectionModel}
                        data={discountCouponList}
                        pageSize={7}
                        columns={[
                            {
                                field: 'subscriptionServiceTypeName',
                                headerName: 'Ürün Tipi',
                                headerAlign: 'center',
                                headerClassName: 'cell-header',
                                cellClassName: 'cell-data',
                                width: 150
                            },
                            {
                                field: 'name',
                                headerName: 'Kampanya Adı',
                                headerAlign: 'center',
                                headerClassName: 'cell-header',
                                cellClassName: 'cell-data',
                                width: 175
                            }, {
                                field: 'subscriptionBillingTypeName',
                                headerName: 'Abonelik Tipi',
                                headerAlign: 'center',
                                headerClassName: 'cell-header',
                                cellClassName: 'cell-data',
                                width: 150
                            }, {
                                field: 'discountTypeName',
                                headerName: 'İndirim Tipi',
                                headerAlign: 'center',
                                headerClassName: 'cell-header',
                                cellClassName: 'cell-data',
                                width: 150
                            }, {
                                field: 'discountRate',
                                headerName: 'İndirim Oranı',
                                headerAlign: 'center',
                                headerClassName: 'cell-header',
                                cellClassName: 'cell-data',
                                width: 150
                            }, {
                                field: 'discountAmount',
                                headerName: 'İndirim Tutarı',
                                headerAlign: 'center',
                                headerClassName: 'cell-header',
                                cellClassName: 'cell-data',
                                width: 150
                            },{
                                field: 'fixedAmount',
                                headerName: 'Sabit Tutar',
                                headerAlign: 'center',
                                headerClassName: 'cell-header',
                                cellClassName: 'cell-data',
                                width: 150
                            }, {
                                field: 'validIntervalBeginDateTime',
                                headerName: 'Kampanya Baş.Trh.',
                                headerAlign: 'center',
                                headerClassName: 'cell-header',
                                cellClassName: 'cell-data',
                                width: 200
                            }, {
                                field: 'validIntervalEndDateTime',
                                headerName: 'Kampanya Btş.Trh.',
                                headerAlign: 'center',
                                headerClassName: 'cell-header',
                                cellClassName: 'cell-data',
                                width: 200
                            }, {
                                field: 'remark',
                                headerName: 'Açıklama',
                                headerAlign: 'center',
                                headerClassName: 'cell-header',
                                cellClassName: 'cell-data',
                                width: 200
                            }, {
                                field: 'declaredFileCount',
                                headerName: 'Dosya',
                                headerAlign: 'center',
                                headerClassName: 'cell-header',
                                cellClassName: 'cell-data',
                                width: 120
                            }, {
                                field: 'declaredUserCount',
                                headerName: 'Kullanıcı',
                                headerAlign: 'center',
                                headerClassName: 'cell-header',
                                cellClassName: 'cell-data',
                                width: 120
                            }, {
                                field: 'declaredTokenCount',
                                headerName: 'Token',
                                headerAlign: 'center',
                                headerClassName: 'cell-header',
                                cellClassName: 'cell-data',
                                width: 120
                            }, {
                                field: 'validityStatusName',
                                headerName: 'Durumu',
                                headerAlign: 'center',
                                headerClassName: 'cell-header',
                                cellClassName: 'cell-data',
                                renderCell: (params: GridRenderCellParams) => (
                                    <strong style={{color:(params.value === "Aktif" ? 'GREEN' : "RED")}}>
                                        {(params.value)}
                                    </strong>
                                ),
                                width: 200
                            }]}/>
                </Card.Body>
                <Card.Footer style={{padding:0}}>
                    {adminManagement &&
                        <div>
                            <Button variant="contained" size="small" onClick={() => {insertDiscountCouponDto()}}>Ekle</Button>
                            <Button variant="contained" size="small" onClick={updateSelectionDiscountCouponDto}>Güncelle</Button>
                            <Button variant="contained" size="small" onClick={generateDiscountCouponCode}>Kupon Üret</Button>
                            <Button variant="contained" size="small" onClick={() => updateStatusDiscountCouponDto("ACTIVE")}>Aktif Et</Button>
                            <Button variant="contained" size="small" onClick={() => updateStatusDiscountCouponDto("PASSIVE")}>Pasif Et</Button>
                            <Button variant="contained" size="small" onClick={getDiscountCouponList}>Yenile</Button>
                        </div>
                    }
                </Card.Footer>
            </Card>
        </Row>
        <Tabs
            className="pt-1 pl-3 tabsColor"
            id="subscription-tabs"
            activeKey={tabKey}
            onSelect={(k) => {
                setTabKey(k)
            }}
        >
            <Tab eventKey="coupon" title="Kupon Bilgileri">
                <Row>
                    <div style={{
                        width: "100%",
                        height: "100%"
                    }}>
                        <Card style={{width: "100%", borderBottom: "none"}}>
                            <Card.Body className="align-items-center align-middle font-weight-bold p-1"
                                       style={{
                                           width: "100%", height: "40vh",
                                       }}>
                                {"Kod Sayısı : "}
                                {discountCouponCodeList.length}
                                <EtcDataGrid
                                    data={discountCouponCodeList}
                                    columns={[
                                        {
                                            field: 'code',
                                            headerName: 'İndirim Kodu',
                                            headerAlign: 'center',
                                            headerClassName: 'cell-header',
                                            cellClassName: 'cell-data',
                                            width: 300
                                        }, {
                                            field: 'creationDateTime',
                                            headerName: 'Üretildiği Tarih',
                                            headerAlign: 'center',
                                            headerClassName: 'cell-header',
                                            cellClassName: 'cell-data',
                                            width: 200
                                        }, {
                                            field: 'couponUsageStatusName',
                                            headerName: 'Kullanım Durumu',
                                            headerAlign: 'center',
                                            headerClassName: 'cell-header',
                                            cellClassName: 'cell-data',
                                            width: 200
                                        }, {
                                            field: 'couponUsageDate',
                                            headerName: 'Kullanım Tarihi',
                                            headerAlign: 'center',
                                            headerClassName: 'cell-header',
                                            cellClassName: 'cell-data',
                                            width: 200
                                        }, {
                                            field: 'userTenantName',
                                            headerName: 'Kullanım Abonelik Bilgisi',
                                            headerAlign: 'center',
                                            headerClassName: 'cell-header',
                                            cellClassName: 'cell-data',
                                            width: 300
                                        }, {
                                            field: 'validityStatusName',
                                            headerName: 'Durumu',
                                            headerAlign: 'center',
                                            headerClassName: 'cell-header',
                                            cellClassName: 'cell-data',
                                            renderCell: (params: GridRenderCellParams) => (
                                                <strong style={{color:(params.value === "Aktif" ? 'GREEN' : "RED")}}>
                                                    {(params.value)}
                                                </strong>
                                            ),
                                            width: 200
                                        }]}
                                    pageSize={20}/>
                            </Card.Body>
                        </Card>
                    </div>
                </Row>

            </Tab>
            <Tab eventKey="couponRelatedTenant" title="Hukuk Büro Bilgileri">
                <Row>
                    <div style={{
                        width: "100%",
                        height: "100%"
                    }}>
                        <Card style={{width: "100%", borderBottom: "none"}}>
                            <Card.Body className="align-items-center align-middle font-weight-bold p-1"
                                       style={{
                                           width: "100%", height: "40vh",
                                       }}>
                                {selectedTenantList && `Seçilen Kurum Sayısı : ${selectedTenantList.length}`}
                                <EtcMultiSelectDataGrid
                                    data={selectedTenantList}
                                    columns={[
                                        {
                                            field: 'hbTamAdi',
                                            headerName: 'Adı',
                                            headerAlign: 'center',
                                            headerClassName: 'cell-header',
                                            cellClassName: 'cell-data',
                                            width: 200
                                        },
                                        {
                                            field: 'hbVergiDairesi',
                                            headerName: 'Vergi Dairesi',
                                            headerAlign: 'center',
                                            headerClassName: 'cell-header',
                                            cellClassName: 'cell-data',
                                            width: 200
                                        },
                                        {
                                            field: 'hbVergiSicilNo',
                                            headerName: 'Vergi Sicil No',
                                            headerAlign: 'center',
                                            headerClassName: 'cell-header',
                                            cellClassName: 'cell-data',
                                            width: 200
                                        },
                                        {
                                            field: 'hbClientContactRefValue',
                                            headerName: 'Referans No',
                                            headerAlign: 'center',
                                            headerClassName: 'cell-header',
                                            cellClassName: 'cell-data',
                                            width: 200
                                        },
                                        {
                                            field: 'hbTelNo',
                                            headerName: 'Tel No',
                                            headerAlign: 'center',
                                            headerClassName: 'cell-header',
                                            cellClassName: 'cell-data',
                                            width: 200
                                        },
                                        {
                                            field: 'hbIlName',
                                            headerName: 'İl',
                                            headerAlign: 'center',
                                            headerClassName: 'cell-header',
                                            cellClassName: 'cell-data',
                                            width: 200
                                        },
                                        {
                                            field: 'hbIlceName',
                                            headerName: 'İlçe',
                                            headerAlign: 'center',
                                            headerClassName: 'cell-header',
                                            cellClassName: 'cell-data',
                                            width: 200
                                        },
                                        {
                                            field: 'hbAdres',
                                            headerName: 'Adres',
                                            headerAlign: 'left',
                                            headerClassName: 'cell-header',
                                            cellClassName: 'cell-data',
                                            width: 1000
                                        },
                                    ]}
                                    pageSize={20}/>
                            </Card.Body>
                        </Card>
                    </div>
                </Row>

            </Tab>

        </Tabs>

        <DiscountCouponInputForm
            style={{width: "100%", height: "100%"}}
            openDialog={openDiscountCouponInputForm}
            openType={openDiscountCouponInputFormType}
            selectedModel={updateSelectionDiscountCoupon}
            handleSave={handleSaveDiscountCouponInputForm}
            handleClose={handleCloseDiscountCouponInputForm}
        />

        <DiscountCodeInputFormDialog
            openDialog={openDiscountCodeInputFormDialog}
            handleAcceptDialog={handleAcceptDiscountCodeInputFormDialog}
            handleCloseDialog={handleCloseDiscountCodeInputFormDialog}
            color={'blue'}
            title={"Kupon Kodu Oluşturma"}
            dialogContentText={"İşlemin tamamlanması için kupon sayısı ve kupon kodu anahtarı sözcüğü giriniz!"}
        />

        <Button style={{float:'right',marginTop: '25px'}} onClick={() => {window.location.reload()}} variant="danger">
            İptal
        </Button>

    </div>)

}

export default DiscountManagerPanel;
